import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { Helmet } from 'react-helmet';

import { Cinema, useCinema } from 'api/cinemaClub';
import { Box, CustomBox, GridChild, GridContainer } from 'common';
import { useEffect, useState } from 'react';
import { CinemaCard } from 'widgets/cards';

import { useLanguage } from '../../context/LanguageContext';
import { cinemaClubPageLabels } from '../../locales/translations'

export const CinemaPage = () => {
    const [cinemaList, setCinemaList] = useState<Cinema[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { language } = useLanguage();
    const title = cinemaClubPageLabels.title[language];
    const pageTitle = cinemaClubPageLabels.pageTitle[language];
    const metaDescription = cinemaClubPageLabels.metaDescription[language];

    const { onGetAllCinema } = useCinema();

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllCinema();
                if (result.success) {
                    const sortedCinema = result.data
                        .filter((a: Cinema) => a.show)
                        .sort((a: Cinema, b: Cinema) =>
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setCinemaList(sortedCinema);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllCinema]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box>
                    <GridContainer>
                        {cinemaList.map((cinemaItem) => (
                            <GridChild md={3} key={cinemaItem.id}>
                                <CinemaCard cinemaItem={cinemaItem} />
                            </GridChild>
                        ))}
                    </GridContainer>
                </Box>
            )}
        </CustomBox>
    );
};
